import Navbar from "components/Navbar";
import Footer from "components/sections/home/HomeFooter";
import PageHeader from "components/PageHeader";
import Map from "components/Map";
import HeroSection from "components/sections/blog/HeroSection";
import AllPosts from "components/sections/blog/AllPosts";
import { useState } from "react";

const Blog = () => {
  const [search, setSearch] = useState("");
  const [save, setSave] = useState(false);
  return (
    <main>
      <PageHeader title="Blog | Smartcomply" />
      <div className="hero">
        <Navbar />
        <HeroSection
          search={search}
          setSearch={setSearch}
          save={save}
          setSave={setSave}
        />
      </div>
      <AllPosts search={search} save={save} />

      <Map />
      <Footer />
    </main>
  );
};

export default Blog;
